export default __webpack_public_path__ + "static/media/cellular-wifi-battery.f255cc3b.svg";